import React from "react";
import { BannerPanel } from "./bannerPanel/view";
import { BannerItem } from "./bannerItem/view";
import { Panel } from "./panel/view";
import { Html } from "./html/view";
import { TestimonialPanel } from "./testimonialPanel/view";
import { TestimonialItem } from "./testimonialItem/view";
import { ImagePanel } from "./imagePanel/view";
import { PageTiles } from "./pageTiles/view";
import { SingleBanner } from "./singleBanner/view";
import { AccordionPanel } from "./accordionPanel/view";
import { ContactForm } from "./contactForm/view";
import { YoutubeBannerPanel } from "./youtubeBannerPanel/view";
import { Code } from "./code/view";
import { BlogPosts } from "./blogPosts/view";
import { BlogPostTitle } from "./blogPostTitle/view";
import { VideoHolder } from "./videoHolder/view";
import { VideoItem } from "./videoItem/view";
import { MultiColumnPanel } from "./multiColumnPanel/view";
import { ExpandableHtml } from "./expandableHtml/view";
import { ProductTiles } from "./productTiles/view";
import { LinkTiles } from "./linkTiles/view";
import { LinkTileItem } from "./linkTileItem/view";
import { ExpandablePanel } from "../../components/expandablePanel/view";
import { WallToWallPanel } from "./wallToWallPanel/view";
import { WallToWallItem } from "./wallToWallItem/view";
import { FullSizeBannerPanel } from "./fullSizeBannerPanel/view";
import { FullSizeBannerItem } from "./fullSizeBannerItem/view";
import { TwoTabsPanel } from "./TwoTabsPanel/view";
import { ProductTilesPanel } from "./productTilesPanel/view";
import { SignupForm } from "./signupForm/view/signupForm";

export function Item(props) {
  const item = props.item;
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};

  //console.log('item', item, subItems, cmsOption);

  let itemElt = <></>;
  if (item.itemTypeCode === "Panel") {
    itemElt = <Panel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Html") {
    itemElt = <Html item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "BannerPanel") {
    itemElt = <BannerPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "BannerItem") {
    itemElt = <BannerItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "TestimonialPanel") {
    itemElt = <TestimonialPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "TestimonialItem") {
    itemElt = <TestimonialItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ImagePanel") {
    itemElt = <ImagePanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "PageTiles") {
    itemElt = <PageTiles item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "SingleBanner") {
    itemElt = <SingleBanner item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "AccordionPanel") {
    itemElt = <AccordionPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ContactForm") {
    itemElt = <ContactForm item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "YoutubeBannerPanel") {
    itemElt = <YoutubeBannerPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Code") {
    itemElt = <Code item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Blog-Posts") {
    itemElt = <BlogPosts item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Blog-PostTitle") {
    itemElt = <BlogPostTitle item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "MultiColumnPanel") {
    itemElt = <MultiColumnPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ExpandableHtml") {
    itemElt = <ExpandableHtml item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "VideoHolder") {
    itemElt = <VideoHolder item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "VideoItem") {
    itemElt = <VideoItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ProductTiles") {
    itemElt = <ProductTiles item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "LinkTiles") {
    itemElt = <LinkTiles item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "LinkTileItem") {
    itemElt = <LinkTileItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ExpandablePanel") {
    itemElt = <ExpandablePanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "WallToWallPanel") {
    itemElt = <WallToWallPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "WallToWallItem") {
    itemElt = <WallToWallItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "FullSizeBannerPanel") {
    itemElt = <FullSizeBannerPanel item={item} cmsOption={cmsOption} />;
  }  else if (item.itemTypeCode === "FullSizeBannerItem") {
    itemElt = <FullSizeBannerItem item={item} cmsOption={cmsOption} activeIndex={props.activeIndex} itemIndex={props.itemIndex} />;
  }  else if (item.itemTypeCode === "TwoTabsPanel") {
    itemElt = <TwoTabsPanel item={item} cmsOption={cmsOption} />;
  }  else if (item.itemTypeCode === "ProductTilesPanel") {
    itemElt = <ProductTilesPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "SignupForm") {
    itemElt = <SignupForm item={item} cmsOption={cmsOption} />;
  }
     else {
    itemElt = <div>{item.itemTypeCode}</div>;
  }

  // const subItemsElts = subItems.map((subItem, index) =>
  //   <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
  // );
  return (
    <>
      {itemElt}
      {/* {subItemsElts} */}
    </>
  );
}
